import type { QueryParameters } from '../types/NavigateOptions';

type Options = {
    withLeadingQuestionMark?: boolean;
};

type QueryParameterValueSimple = string | number | boolean;

/**
 * Formats the given key-value map to the query string - with encoded value.
 * @param {QueryParameters} queryParameters
 * @param {Options} params
 */
export const createQueryString = (
    queryParameters?: QueryParameters,
    { withLeadingQuestionMark }: Options = { withLeadingQuestionMark: true },
): string => {
    if (!queryParameters || Object.keys(queryParameters).length === 0) {
        return '';
    }

    const queryString = Object.entries(queryParameters)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return value
                    .map((arrayValue) => `${key}=${encodeURIComponent(arrayValue)}`)
                    .join('&');
            }
            if (value === null) {
                return `${key}=null`;
            }
            return `${key}=${encodeURIComponent(value as QueryParameterValueSimple)}`;
        })
        .join('&');

    return `${withLeadingQuestionMark ? '?' : ''}${queryString}`;
};
